export default __webpack_public_path__ + "static/media/blizzard-large-sack.761f7e68.png";